import React from 'react';

import {
  Box,
  Stack,
  styled
} from '@mui/material';
import {
  activityTemplates,
  AllAccessWall,
  AuthWrapper,
  CancelSubscriptionModal,
  DeleteAccountModal,
  ProfileSection
} from 'modules';

import { BeginSubscriptionSection } from './BeginSubscriptionSection/BeginSubscriptionSection';
import { EditAccountSection } from './EditAccountSection/EditAccountSection';
import { EditPaymentSection } from './EditPaymentSection/EditPaymentSection';
import { EditProfileSection } from './EditProfileSection/EditProfileSection';
import { TopLevelDetailsSection } from './TopLevelDetailsSection/TopLevelDetailsSection';



const DeleteAccountBox = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '10px'
});



export const MyProfileActivity: React.FC = () => {
  return (
    <AuthWrapper.FC>
      <activityTemplates.BaseActivityTemplate.FC>
        <Stack spacing={10}>
          <TopLevelDetailsSection />

          <Stack spacing={1}>
            <BeginSubscriptionSection />
            <EditProfileSection />
          </Stack>


          <AllAccessWall.FC mode="hideInAllAccess">
            <ProfileSection.FC title="Edit Payment">
              <EditPaymentSection />
            </ProfileSection.FC>
          </AllAccessWall.FC>

          <ProfileSection.FC title="Edit Account">
            <EditAccountSection />
          </ProfileSection.FC>

          <DeleteAccountBox>
            <CancelSubscriptionModal.FC />

            <DeleteAccountModal.FC />
          </DeleteAccountBox>

        </Stack>
      </activityTemplates.BaseActivityTemplate.FC>
    </AuthWrapper.FC>
  );
};
